import OutsideClickHandler from 'react-outside-click-handler';
import { LinkButton, Popover } from '@festo-ui/react';
import React, { useState } from 'react';
import { useTranslation } from '../../hooks/useTranslation';
import { SORT_ASCENDING, SORT_DESCENDING } from '../../features/media-resistance/MediaResistance';
import { econdaClickEvent } from '../../Econda';
import './SortBy.scss';

interface RankingProps {
  sortBy: string;
  sortDirection: string;
  setSortby: (sortBy: string) => void;
  setSortDirection: (sortDirection: string) => void;
}

function SortBy(props: RankingProps): JSX.Element {
  const t = useTranslation();

  const [showPopper, setShowPopper] = useState(false);
  const [isOpen, setIsOpen] = useState(false);

  return (
    <div className="ems-ranking sort-by fwe-d-flex fwe-justify-content-flex-end">
      <div className="sort-by-text">{t('sortByTranslation')}</div>
      <OutsideClickHandler onOutsideClick={() => setIsOpen(false)}>
        <Popover
          open={showPopper}
          onStatusChange={setShowPopper}
          popoverContent={
            <div data-testid="ranking-popover-content">
              <ul className="fwe-list-group">
                <li
                  className="ems-list-group-item"
                  onClick={() => {
                    props.setSortby('MEDIA');
                    props.setSortDirection(SORT_ASCENDING);
                    econdaClickEvent('sort by', 'general', 'sort by button', 'A-Z Media');
                  }}
                >
                  <LinkButton
                    className={`${
                      props.sortBy === 'MEDIA' && props.sortDirection === SORT_ASCENDING && 'fwe-color-caerul'
                    }`}
                  >
                    {t('sortByMediaAZ')}
                  </LinkButton>
                  <i
                    className={`fwe-icon fwe-ml-2 ${
                      props.sortBy === 'MEDIA' &&
                      props.sortDirection === SORT_ASCENDING &&
                      'fwe-icon-menu-check fwe-color-caerul'
                    }`}
                  ></i>
                </li>
                <li
                  className="ems-list-group-item"
                  onClick={() => {
                    props.setSortby('MEDIA');
                    props.setSortDirection(SORT_DESCENDING);
                    econdaClickEvent('sort by', 'general', 'sort by button', 'Z-A Media');
                  }}
                >
                  <LinkButton
                    className={`${
                      props.sortBy === 'MEDIA' && props.sortDirection === SORT_DESCENDING && 'fwe-color-caerul'
                    }`}
                  >
                    {t('sortByMediaZA')}
                  </LinkButton>
                  <i
                    className={`fwe-icon fwe-ml-2 ${
                      props.sortBy === 'MEDIA' &&
                      props.sortDirection === SORT_DESCENDING &&
                      'fwe-icon-menu-check fwe-color-caerul'
                    }`}
                  ></i>
                </li>
                <li
                  className="ems-list-group-item"
                  onClick={() => {
                    props.setSortby('MATERIAL');
                    props.setSortDirection(SORT_ASCENDING);
                    econdaClickEvent('sort by', 'general', 'sort by button', 'A-Z Material');
                  }}
                >
                  <LinkButton
                    className={`${
                      props.sortBy === 'MATERIAL' && props.sortDirection === SORT_ASCENDING && 'fwe-color-caerul'
                    }`}
                  >
                    {t('sortByMaterialAZ')}
                  </LinkButton>
                  <i
                    className={`fwe-icon fwe-ml-2 ${
                      props.sortBy === 'MATERIAL' &&
                      props.sortDirection === SORT_ASCENDING &&
                      'fwe-icon-menu-check fwe-color-caerul'
                    }`}
                  ></i>
                </li>
                <li
                  className="ems-list-group-item"
                  onClick={() => {
                    props.setSortby('MATERIAL');
                    props.setSortDirection(SORT_DESCENDING);
                    econdaClickEvent('sort by', 'general', 'sort by button', 'Z-A Material');
                  }}
                >
                  <LinkButton
                    className={`${
                      props.sortBy === 'MATERIAL' && props.sortDirection === SORT_DESCENDING && 'fwe-color-caerul'
                    }`}
                  >
                    {t('sortByMaterialZA')}
                  </LinkButton>
                  <i
                    className={`fwe-icon fwe-ml-2 ${
                      props.sortBy === 'MATERIAL' &&
                      props.sortDirection === SORT_DESCENDING &&
                      'fwe-icon-menu-check fwe-color-caerul'
                    }`}
                  ></i>
                </li>
              </ul>
            </div>
          }
        >
          <LinkButton
            className="round-button fwe-dark round-button-override"
            icon={`fwe-icon ${isOpen ? 'fwe-icon-menu-close' : 'fwe-icon-sort-by'}`}
            onClick={() => {
              setIsOpen(!isOpen);
              econdaClickEvent('sort by', 'general', 'sort by button', 'click');
            }}
          />
        </Popover>
      </OutsideClickHandler>
    </div>
  );
}

export default SortBy;
